module.exports = __webpack_public_path__ + "static/img/Eiffel-Tower-Stadium.960a440.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Eiffel-Tower-Stadium.jpg
// module id = Rm9K
// module chunks = 0